module.exports = __webpack_public_path__ + "static/media/folder-plus.4cbb9686.svg";